import React from "react";
import { connect } from "react-redux";
import { Button } from "devextreme-react";
import CardTabs from "../../../../Shared/CardTabs";
import { doGetSucursalData } from "./actions";
import validaciones from "../../../../../helpers/validaciones";

class SucursalDetails extends React.PureComponent {
  componentDidUpdate = (prevProps) => {
    if (this.props.selectedSucursal.idSucursal && this.props.selectedSucursal.idSucursal !== prevProps.selectedSucursal.idSucursal) {
      this.props.dispatch(doGetSucursalData(this.props.companyId, this.props.selectedSucursal.idSucursal));
    }
  }

  getSucursalData = () => {
    const { sucursalDetails } = this.props;
    const agencia = sucursalDetails.agenciaACHS || {};
    const conComercial = sucursalDetails.contactoComercial || {};
    const conPreventivo = sucursalDetails.contactoPreventivo || {};
    const Data = {};
    Data.className = "col-5";
    Data.background = "#007A33";
    Data.backgroudColor = "#e6f7f6";
    Data.Title = this.props.selectedSucursal.Direccion || "Sin datos";
    Data.LettersCircle = `${validaciones.getFirstLetter(this.props.selectedSucursal.Direccion)}`;
    Data.subTitle = this.props.selectedSucursal.Ciudad;
    Data.Tabs = [
      {
        text: "Contacto comercial",
        tooltipo: { icono: "", text: "" },
        hasSeccion: false,
        idTab: "tab1",
        data: [
          {
            label: "Nombre", value: conComercial.nombreCompleto || "Sin datos",
          },
          {
            label: "Correo", value: conComercial.email || "Sin datos",
          },
          {
            label: "Celular", value: conComercial.telefonoCelular || "Sin datos",
          },
          {
            label: "teléfono fijo", value: conComercial.telefonoFijo || "Sin datos",
          },
        ],
      },
      {
        text: "Contacto preventivo",
        tooltipo: { icono: "", text: "" },
        hasSeccion: false,
        idTab: "tab2",
        data: [
          {
            label: "Nombre", value: conPreventivo.nombreCompleto || "Sin datos",
          },
          {
            label: "Correo", value: conPreventivo.email || "Sin datos",
          },
          {
            label: "Celular", value: conPreventivo.telefonoCelular || "Sin datos",
          },
          {
            label: "Teléfono fijo", value: conPreventivo.telefonoFijo || "Sin datos",
          },
        ],
      },
      {
        text: "Agencia ACHS",
        tooltipo: { icono: "", text: "" },
        hasSeccion: false,
        idTab: "tab3",
        data: [
          {
            label: "Nombre de Sede",
            value: agencia.nombreAgencia || "Sin datos",
          },
          {
            label: "Dirección",
            value: agencia.direccionAgencia || "Sin datos",
          },
          {
            label: "Horario",
            // value: agencia.horaApertura ? `${agencia.horaApertura} a ${agencia.horaCierre}` : "Sin datos",
            value: "VER 🔎",
            type: 'LINK',
            url: process.env.REACT_APP_ACHS_HORARIOS,
            tooltip: 'Click para revisar horarios de sucursales'
          },
        ],
      },
    ];
    return [
      Data,
    ];
  }

  handleBack = () => {
    this.props.goBack();
  }


  render() {
    return (
      <div>
        <div style={{ marginRight: 5, marginLeft: 5 }}>
          <CardTabs
            goBackCallback={this.handleBack}
            userData={this.getSucursalData()}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  sucursalId: state.global.sucursalId,
  sucursalName: state.global.sucursalName,
  companyId: state.global.companyId,
  sucursalDetails: state.detalleEmpresa.sucursalDetails,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(SucursalDetails);
